import actions from "./actions";

const initState = {
    createBankAccountStatus: false, // request, success, error
    createBankAccountResult: null,
    readState: false,
    updateBankAccountStatus: false,
    accounts: [],
    account: {
        parent_id: null,
        currency_code: undefined,
        code: undefined,
        name: undefined,
        description: undefined,
    },
    parentId: null,
    archiveState: null,
    deleteState: null,
};
let account;

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_BANK_ACCOUNTS_SUCCESS:
            return {
                ...state,
                accounts: action.accounts,
            };
        case actions.READ_BANK_ACCOUNT_REQUEST:
            return {
                ...state,
                readState: 'request',
            };
        case actions.READ_BANK_ACCOUNT_SUCCESS:
            return {
                ...state,
                readState: 'success',
                account: action.account,
                parentId: action.account.parent_id,
            };
        case actions.POPULATE_BANK_ACCOUNT:
            account = {
                ...(action.reset ? initState.account : state.account),
                ...action.request,
            };

            return {
                ...state,
                account,
                parentId: account.parent_id,
            };
        case actions.CREATE_BANK_ACCOUNT_REQUEST:
            return {
                ...state,
                createBankAccountStatus: 'request',
            };
        case actions.CREATE_BANK_ACCOUNT_SUCCESS:
            return {
                ...state,
                createBankAccountStatus: 'success',
                createBankAccountResult: action.account,
            };
        case actions.UPDATE_BANK_ACCOUNT_REQUEST:
            return {
                ...state,
                updateBankAccountStatus: 'request',
            };
        case actions.UPDATE_BANK_ACCOUNT_SUCCESS:
            return {
                ...state,
                updateBankAccountStatus: 'success',
            };
        case actions.BANK_ACCOUNT_SET_PARENT_ID:
            return {
                ...state,
                parentId: action.parentId,
            };
        case actions.BANK_ACCOUNT_ARCHIVE_REQUEST:
            return {
                ...state,
                archiveState: 'request',
            };
        case actions.BANK_ACCOUNT_ARCHIVE_SUCCESS:
            return {
                ...state,
                archiveState: 'success',
            };
        case actions.BANK_ACCOUNT_DELETE_REQUEST:
            return {
                ...state,
                deleteState: 'request',
            };
        case actions.BANK_ACCOUNT_DELETE_SUCCESS:
            return {
                ...state,
                deleteState: 'success',
            };
        case actions.ADD_BANK_ACCOUNT:
            return {
                ...state,
                accounts: [...state.accounts, action.bankAcc],
            };
        case actions.RESET_BANK_ACCOUNT:
            return {
                ...state,
                account: initState.account,
            };
        default:
            return state;
    }
}
